import { InfoWindow } from '@react-google-maps/api';
import React, { ReactElement, useEffect, useRef } from 'react';
import { mapCoordinatesToLatLng } from '@hotelplan/components.common.map-pin';
import { BsIcon } from '@hotelplan/core.basis.bs-icon';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import {
  FdrAgencyDetailedInfo,
  IFdrAgencyDetailedInfoProps,
} from './fdr-agency-map-detailed-info';
import {
  FdrAgencyIcon,
  FdrAgencyIconBlock,
  FdrAgencyPinIconWrapper,
} from './fdr-agency-map.styles';

interface IFdrAgencyPinIconProps extends IFdrAgencyDetailedInfoProps {
  agencyIcon: string;
  pinIcon: string;
  showDetailedInfo?: boolean;
  setActiveAgency?(agencyId: string): void;
}

export function FdrAgencyPinIcon({
  agencyIcon,
  pinIcon,
  agency,
  showDetailedInfo,
  setActiveAgency,
}: IFdrAgencyPinIconProps): ReactElement {
  const { mobile } = useDeviceType();
  const pinRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const agencyPin = pinRef.current;

    if (agencyPin) {
      agencyPin.addEventListener(mobile ? `click` : `mouseenter`, () => {
        setActiveAgency(agency.id);
      });
    }

    return function cleanupEvents() {
      agencyPin.addEventListener(mobile ? `click` : `mouseenter`, () => {
        setActiveAgency(agency.id);
      });
    };
  });

  return (
    <FdrAgencyPinIconWrapper>
      {showDetailedInfo ? (
        <InfoWindow position={mapCoordinatesToLatLng(agency.coordinates)}>
          <FdrAgencyDetailedInfo
            agency={agency}
            close={() => setActiveAgency(undefined)}
          />
        </InfoWindow>
      ) : null}
      <FdrAgencyIconBlock ref={pinRef}>
        <FdrAgencyIcon name={agencyIcon} size={'sm'} />
        <BsIcon name={pinIcon} size={'xxlg'} />
      </FdrAgencyIconBlock>
    </FdrAgencyPinIconWrapper>
  );
}
